import { render, staticRenderFns } from "./ThgVehicleDetail.vue?vue&type=template&id=784127c4"
import script from "./ThgVehicleDetail.vue?vue&type=script&lang=ts"
export * from "./ThgVehicleDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports